import { Component} from '@angular/core';
import {OrganizationService} from "../../../services/organization.service";
import {AbstractProdForm, ProdFormField, ProdFormFieldType, ProdFormValidators, RequiredValidator} from 'prod-form';
import {CompanyService} from "../../../services/company.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-distributor-form',
  templateUrl: './distributor-form.component.html'
})
export class DistributorFormComponent extends AbstractProdForm {
  title: string = this.translate.instant('distributor.form.title');
  style = {inputWidth: '250px'};
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'name',
      label: this.translate.instant('distributor.form.name'),
      type: ProdFormFieldType.TEXT,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
    }),
    ProdFormField.create({
      name: 'distributedCompanies',
      label: this.translate.instant('distributor.form.distributed_companies'),
      type: ProdFormFieldType.SELECT,
      selectParameters: {
        selectDataService: CompanyService,
        isMulti: true,
        isNarrowDown: true,
        isComplete: true
      }
    }),
    ProdFormField.create({
      name: 'description',
      label: this.translate.instant('distributor.form.description'),
      type: ProdFormFieldType.TEXTAREA,
    }),
    ProdFormField.create({
      name: 'organizationType',
      label: '',
      type: ProdFormFieldType.HIDDEN,
      value: 3, // Distributor
      isEditable: false
    }),
  ];

  constructor(override dataService: OrganizationService, private translate: TranslateService) {
    super();
  }
}
